import config from '@config/config';

import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';

const { GET, POST } = api;

const OAUTH_RESOURCE_BASE_PATH = `${config.identityServiceBasePath}`;

export interface OAuthResource {
  logout: () => ResourceFetch<any>;
  extLogout: (url: string) => ResourceFetch<any>;
  createTrialAccount: ResourceFetch<void, { accountId: string; userId: string }>;
}

const OAuthResource: OAuthResource = {
  logout: () =>
    GET(`${OAUTH_RESOURCE_BASE_PATH}/logout?client_id=${config.clientId}`, {
      authenticated: false,
      withCredentials: true,
    }),
  extLogout: (url: string) =>
    GET(url, {
      authenticated: false,
      withCredentials: true,
    }),
  createTrialAccount: POST(
    `${OAUTH_RESOURCE_BASE_PATH}/accounts/:accountId/start-trial?userId=:userId`,
  ),
};

export default OAuthResource;
